<svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_5141_45166)">
<path d="M3.08317 9.33464C2.4415 9.33464 1.9165 8.80964 1.9165 8.16797V2.33464C1.9165 1.69297 2.4415 1.16797 3.08317 1.16797H8.9165C9.55817 1.16797 10.0832 1.69297 10.0832 2.33464M6.58317 4.66797H12.4165C13.0608 4.66797 13.5832 5.1903 13.5832 5.83464V11.668C13.5832 12.3123 13.0608 12.8346 12.4165 12.8346H6.58317C5.93884 12.8346 5.4165 12.3123 5.4165 11.668V5.83464C5.4165 5.1903 5.93884 4.66797 6.58317 4.66797Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<defs>
<clipPath id="clip0_5141_45166">
<rect width="14" height="14" fill="white" transform="translate(0.75)"/>
</clipPath>
</defs>
</svg>
